import { useMemo } from 'react';

const generalCreateMarkup = (body) => {
  return { __html: body };
};

const useCreateMarkup = () => {
  const createMarkup = (value) => {
    return useMemo(() => {
      return generalCreateMarkup(value);
    }, [value]);
  };

  return { createMarkup };
};

export default useCreateMarkup;
